import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import MarketingLayout from "@/components/marketing/MarketingLayout"

export default function Help() {
  const { t } = useTranslation()
  const categories = t("pages.help.categories", { returnObjects: true, defaultValue: [] })
  const list = Array.isArray(categories) ? categories : []

  return (
    <MarketingLayout seoKey="help">
      <div className="pt-36 pb-24">
        <div className="mx-auto max-w-3xl px-6 lg:px-10">
          <p className="text-xs tracking-[0.2em] uppercase font-semibold text-muted-foreground mb-5">
            {t("pages.help.eyebrow")}
          </p>
          <h1 className="font-display text-4xl md:text-5xl tracking-tighter font-medium">{t("pages.help.title")}</h1>
          <p className="mt-6 text-lg text-muted-foreground">{t("pages.help.subtitle")}</p>
        </div>

        <div className="mx-auto max-w-3xl px-6 lg:px-10 mt-12 grid gap-6">
          {list.map((cat) => (
            <section key={cat.title} className="rounded-2xl border border-border p-6">
              <h2 className="font-display text-xl tracking-tight font-medium">{cat.title}</h2>
              <ul className="mt-4 space-y-2">
                {(cat.links || []).map((link) => (
                  <li key={link.label}>
                    <Link to={link.href} className="text-sm text-muted-foreground hover:text-foreground">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>

        <p className="mx-auto max-w-3xl px-6 lg:px-10 mt-10 text-sm text-muted-foreground">
          {t("pages.help.more")}{" "}
          <Link to="/contact" className="text-accent hover:underline">
            {t("footer.contact")}
          </Link>
          {" · "}
          <Link to="/pricing#faq" className="text-accent hover:underline">
            {t("nav.faq")}
          </Link>
        </p>
      </div>
    </MarketingLayout>
  )
}
